import { BETA_FEATURE_INCREASE_SAMPLE_SIZE } from '@/lib/betaFeatures';
import { sortBy, uniqBy } from 'lodash';
import { useMemo } from 'react';
import useBetaFeatureEnabled from './useBetaFeatureEnabled';

type SampleSize = {
  isDefault: boolean;
  value: number;
};

export const useSampleSizes = (sampleSizes: SampleSize[]) => {
  const shouldIncreaseSampleSize = useBetaFeatureEnabled(
    BETA_FEATURE_INCREASE_SAMPLE_SIZE
  );

  return useMemo(() => {
    if (!shouldIncreaseSampleSize) return sampleSizes;

    return sortBy(
      uniqBy(
        [
          { isDefault: true, value: 2500 },
          ...sampleSizes.map(sampleSize => ({
            ...sampleSize,
            isDefault: false
          }))
        ],
        'value'
      ),
      'value'
    );
  }, [sampleSizes, shouldIncreaseSampleSize]);
};
